export const AVATAR_COLORS = [
   "#2589BD",
   "#FAA6FF",
   "#FB8B24",
   "#BB0A21",
   "#226F54"
]